import tw from "twin.macro";

export const SectionHeading = tw.h2`text-2.5xl sm:text-3xl lg:text-5xl font-black tracking-wide text-center`
export const SectionHeadingThin = tw.p` text-2.5xl sm:text-3xl text-center lg:text-5xl font-black tracking-wide font-thin`
export const Subheading = tw.h2`font-bold text-primary-500`
